"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var AXSBlock_1 = __importDefault(require("../../layout/AXSBlock/AXSBlock"));
var utils_1 = require("../../utils");
/**
 * A simple placeholder for text and images, based on Semantic UI placeholder.
 */
var Placeholder = styled_components_1.default(AXSBlock_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: static;\n    overflow: hidden;\n    -webkit-animation: placeholderShimmer 2s linear;\n    animation: placeholderShimmer 2s linear;\n    -webkit-animation-iteration-count: infinite;\n    animation-iteration-count: infinite;\n    background-color: #fff;\n    background-image: ", ";\n    background-size: 1200px 100%;\n    height: ", ";\n    width: ", ";\n\n    &.line + .line {\n      margin-top: 8px;\n    }\n\n    &.image {\n      height: ", ";\n      width: ", ";\n    }\n\n\n@-webkit-keyframes placeholderShimmer {\n    0% {\n        background-position: -1200px 0\n    }\n    100% {\n        background-position: 1200px 0\n    }\n}\n\n@keyframes placeholderShimmer {\n    0% {\n        background-position: -1200px 0\n    }\n    100% {\n        background-position: 1200px 0\n    }\n}\n"], ["\n    position: static;\n    overflow: hidden;\n    -webkit-animation: placeholderShimmer 2s linear;\n    animation: placeholderShimmer 2s linear;\n    -webkit-animation-iteration-count: infinite;\n    animation-iteration-count: infinite;\n    background-color: #fff;\n    background-image: ",
    ";\n    background-size: 1200px 100%;\n    height: ", ";\n    width: ", ";\n\n    &.line + .line {\n      margin-top: 8px;\n    }\n\n    &.image {\n      height: ", ";\n      width: ", ";\n    }\n\n\n@-webkit-keyframes placeholderShimmer {\n    0% {\n        background-position: -1200px 0\n    }\n    100% {\n        background-position: 1200px 0\n    }\n}\n\n@keyframes placeholderShimmer {\n    0% {\n        background-position: -1200px 0\n    }\n    100% {\n        background-position: 1200px 0\n    }\n}\n"])), function (_a) {
    var theme = _a.theme, color = _a.color, colorHighlight = _a.colorHighlight;
    return "linear-gradient(135deg, " + utils_1.parseThemePath(color, theme, '#dedede') + " 35%, " + utils_1.parseThemePath(colorHighlight, theme, '#ededed') + " 48%, " + utils_1.parseThemePath(color, theme, '#dedede') + " 60%)";
}, function (_a) {
    var height = _a.height;
    return height;
}, function (_a) {
    var width = _a.width;
    return width ? width : '100%';
}, function (_a) {
    var height = _a.height;
    return height ? height : '100%';
}, function (_a) {
    var width = _a.width;
    return width ? width : '100%';
});
var AXSPlaceholder = function (_a) {
    var borderRadius = _a.borderRadius, borderRadiusTopRight = _a.borderRadiusTopRight, borderRadiusTopLeft = _a.borderRadiusTopLeft, borderRadiusBottomRight = _a.borderRadiusBottomRight, borderRadiusBottomLeft = _a.borderRadiusBottomLeft, color = _a.color, colorHighlight = _a.colorHighlight, line = _a.line, lines = _a.lines, image = _a.image, height = _a.height, width = _a.width;
    if (lines) {
        return (React.createElement(React.Fragment, null,
            React.createElement(Placeholder, { borderRadius: borderRadius, className: "line", color: color, colorHighlight: colorHighlight, height: height, width: width }),
            React.createElement(Placeholder, { borderRadius: borderRadius, className: "line", color: color, colorHighlight: colorHighlight, height: height, width: width }),
            React.createElement(Placeholder, { borderRadius: borderRadius, className: "line", color: color, colorHighlight: colorHighlight, height: height, width: width })));
    }
    if (line) {
        return React.createElement(Placeholder, { borderRadius: borderRadius, className: "line", color: color, colorHighlight: colorHighlight, height: height, width: width });
    }
    if (image) {
        return React.createElement(Placeholder, { borderRadius: borderRadius, borderRadiusBottomLeft: borderRadiusBottomLeft, borderRadiusBottomRight: borderRadiusBottomRight, borderRadiusTopLeft: borderRadiusTopLeft, borderRadiusTopRight: borderRadiusTopRight, className: "image", color: color, colorHighlight: colorHighlight, height: height, width: width });
    }
};
AXSPlaceholder.defaultProps = {
    borderRadius: '8px',
    color: 'axsui.components.placeholder.color',
    colorHighlight: 'axsui.components.placeholder.colorHighlight',
    height: '8px',
};
exports.default = AXSPlaceholder;
var templateObject_1;
//# sourceMappingURL=index.js.map